import clsx from "clsx";
import React from "react";
import styles from "./text.style";

const Text = ({
  children,
  color = "text-white",
  font = "ParagraphLarge",
  hover,
  isHoverAnimation = true
}) => {
  return (
    <>
      <div
        className={clsx([
          styles.font[font],
          color,
          styles.text,
          styles.textHover[hover],
        ])}
      >
        {children}
        { isHoverAnimation && <span class="block max-w-0 group-hover:max-w-full transition-all duration-500 h-0.5 bg-lightBorder"></span>}
      </div>
    </>
  );
};

export default Text;
